module.exports = __webpack_public_path__ + "img/balance-chart-low.3cd58fea.svg";